import api from "./api";

const buildQueryParams = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.createdBy) queryParams.append("createdBy", params.createdBy);
  if (params.fromDate) queryParams.append("fromDate", params.fromDate);
  if (params.toDate) queryParams.append("toDate", params.toDate);
  if (params.statusCode) queryParams.append("statusCode", params.statusCode);
  if (params.productVerticalCode) queryParams.append("productVerticalCode", params.productVerticalCode);
  if (params.countryCode) queryParams.append("countryCode", params.countryCode);
  if (params.zoneCode) queryParams.append("zoneCode", params.zoneCode);
  if (params.regionCode) queryParams.append("regionCode", params.regionCode);
  if (params.territoryCode) queryParams.append("territoryCode", params.territoryCode);
  if (params.invoiceNumber) queryParams.append("invoiceNumber", params.invoiceNumber);
  if (params.salesExecutiveName) queryParams.append("salesExecutiveName", params.salesExecutiveName);
  const cc =
    params.complaintCategory != null ? String(params.complaintCategory).trim() : "";
  if (cc) queryParams.append("complaintCategory", cc);
  return queryParams;
};

export const approverDashboardAPI = {
  getApproverDashboardData: async (params = {}, axiosConfig = {}) => {
    const queryParams = buildQueryParams(params);
    const response = await api.get(
      `/api/approver-dashboard/approver-dashboard-data${
        queryParams.toString() ? `?${queryParams}` : ""
      }`,
      axiosConfig
    );
    return response.data;
  },

  getSRStatuses: async (isActive = true) => {
    const queryParams = new URLSearchParams();
    if (isActive !== undefined) queryParams.append("isActive", isActive);
    const response = await api.get(
      `/api/approver-dashboard/status-options${
        queryParams.toString() ? `?${queryParams}` : ""
      }`
    );
    return response.data;
  },

  getProductVerticalOptions: async ({
    isActive = true,
    marketCode = null,
    searchText = null,
    pageNumber = 1,
    pageSize = 500,
  } = {}) => {
    const queryParams = new URLSearchParams();
    if (isActive !== undefined) queryParams.append("isActive", isActive);
    if (marketCode) queryParams.append("marketCode", marketCode);
    if (searchText) queryParams.append("searchText", searchText);
    queryParams.append("pageNumber", pageNumber);
    queryParams.append("pageSize", pageSize);

    const response = await api.get(
      `/api/approver-dashboard/product-vertical-options?${queryParams}`
    );
    return response.data;
  },

  getCountries: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.isActive !== undefined) queryParams.append("isActive", params.isActive);
    const response = await api.get(
      `/api/approver-dashboard/countries${queryParams.toString() ? `?${queryParams}` : ""}`
    );
    return response.data;
  },

  getZones: async (countryCode, isActive = true) => {
    const queryParams = new URLSearchParams();
    if (countryCode) queryParams.append("countryCode", countryCode);
    if (isActive !== undefined) queryParams.append("isActive", isActive);
    const response = await api.get(
      `/api/approver-dashboard/zones${queryParams.toString() ? `?${queryParams}` : ""}`
    );
    return response.data;
  },

  getRegions: async (countryCode, zoneCode, isActive = true) => {
    const queryParams = new URLSearchParams();
    if (countryCode) queryParams.append("countryCode", countryCode);
    if (zoneCode) queryParams.append("zoneCode", zoneCode);
    if (isActive !== undefined) queryParams.append("isActive", isActive);
    const response = await api.get(
      `/api/approver-dashboard/regions${queryParams.toString() ? `?${queryParams}` : ""}`
    );
    return response.data;
  },

  getTerritories: async (countryCode, zoneCode, regionCode, isActive = true) => {
    const queryParams = new URLSearchParams();
    if (countryCode) queryParams.append("countryCode", countryCode);
    if (zoneCode) queryParams.append("zoneCode", zoneCode);
    if (regionCode) queryParams.append("regionCode", regionCode);
    if (isActive !== undefined) queryParams.append("isActive", isActive);
    const response = await api.get(
      `/api/approver-dashboard/territories${queryParams.toString() ? `?${queryParams}` : ""}`
    );
    return response.data;
  },

  getSrCategories: async () => {
    const response = await api.get("/api/approver-dashboard/sr-categories");
    return response.data;
  },
};

